module.exports = __webpack_public_path__ + "static/img/cop_sch_logo12.c2de4a33.png";